import React, { useEffect, useState } from 'react';
import { DEFAULT_DRIVER_DATA, DEFAULT_VEHICAL_CHECK_LIST } from '../Data/DefaultHFTaskData';
import { useDispatch } from 'react-redux';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from '@jumbo/constants/ActionTypes';
import { useAllUsers } from 'context/AllUserDataContext';

const useGenTasksFormEditHook = (taskData, open, setOpen, handleSuccessfulSubmit) => {
  const { allUsers } = useAllUsers();
  const dispatch = useDispatch();

  //clock in data //vehical check list data`
  const [vehicalCheckList, setVehicalChecklist] = useState(DEFAULT_VEHICAL_CHECK_LIST);

  //harveshing maintencance

  //files
  const [files, setFiles] = useState([]);
  const [newUploadedFiles, setNewUploadedFiles] = useState([]);

  //driving Data
  const [drivingData, setDrivingData] = useState(DEFAULT_DRIVER_DATA);

  //general Data
  const [generalFormData, setGeneralFormData] = useState({});

  //expense data
  const [expenseClaimData, setExpenseClaimData] = useState({});

  //const replair and maintance Data
  const [repairAndmaintananceData, setRepairAndmaintananceData] = useState({});

  useEffect(() => {
    if (open && taskData) {
      getTaskInfo();
    }
  }, [taskData, open]);
  const handleClose = () => {
    setOpen(false);
    setFiles([]);
    setNewUploadedFiles([]);

    // ✅ Reset all form data states
    setDrivingData(DEFAULT_DRIVER_DATA);
    setGeneralFormData({});
    setRepairAndmaintananceData({});
    setExpenseClaimData({});
    setVehicalChecklist(DEFAULT_VEHICAL_CHECK_LIST);
  };

  const getTaskInfo = () => {
    const taskType = taskData.task;

    if (taskType == 'Vehicle Check List') {
      //driving data
      //checllist
      let newDrivingData = {
        dateAndTime: taskData.dateAndTime
          ? taskData.dateAndTime.length > 16
            ? taskData.dateAndTime.substring(0, 16)
            : taskData.dateAndTime
          : '',
        employeeName: taskData.employeeName,
        task: taskData.task,
        vehicle: taskData.vehicle,
        trailer: taskData.trailer,
        mileageReadingKM: taskData.mileageReadingKM,
        vehicleCheckListCompleted: taskData.vehicleCheckListCompleted,
        additionalInformation: taskData.additionalInformation,
        geolocationLatitude: parseFloat(taskData.geolocationLatitude),
        geolocationLongitude: parseFloat(taskData.geolocationLongitude),
      };

      setDrivingData(newDrivingData);
      getVehicalCheckList();
    } else if (taskType === 'Administration') {
      //GenTaskCommon
      //basic
      setGeneralFormData({ ...taskData });
    } else if (taskType == 'Moisture Content') {
      //basic
      //GenTaskCommon
      setGeneralFormData({ ...taskData });
    } else if (taskType === 'Clock Out') {
      //basic with stay option
      setGeneralFormData({ ...taskData });
    } else if (taskType == 'Chainsaw') {
      //bacic
      //GenTaskCommon
      setGeneralFormData({ ...taskData });
    } else if (taskType == 'Other') {
      //basic
      setGeneralFormData({ ...taskData });

      //GenTaskCommon
    } else if (taskType == 'Break') {
      //basic with duration ip
      //GenTaskCommon
      setGeneralFormData({ ...taskData });
    } else if (taskType == 'Cancel') {
      //GenTaskCommon
      //basic
      setGeneralFormData({ ...taskData });
    } else if (taskType == 'Expense Claim') {
      setExpenseClaimData({ ...taskData });
      getDocs();
    } else if (taskType == 'Repairs & Maintainance') {
      //checklist
      //files
      //basic data
      //Repairs

      setRepairAndmaintananceData({ ...taskData });
      getDocs();
      getVehicalCheckList();
    } else if (taskType === 'External Repairs') {
      //checklist files and basic
      //Repairs
      setRepairAndmaintananceData({ ...taskData });

      getVehicalCheckList();
    }
  };
  const getVehicalCheckList = () => {
    let url = '/GenTasks/GetTasksVehicleChecklist/' + taskData.id;
    customAxios.get(url, { headers: authHeader() }).then(response => {
      if (response.status === 200) {
        setVehicalChecklist(response.data.length > 0 ? response.data[0] : DEFAULT_VEHICAL_CHECK_LIST);
      }
    });
  };
  const EditVehicalCheckListData = (name, value) => {
    setVehicalChecklist(prev => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  // const getDocs = () => {
  //   let url = `/GenTasks/GetTasksDocs/${taskData.id}`;
  //   customAxios
  //     .get(url, { headers: authHeader() })
  //     .then(res => {
  //       if (res.status === 200) {
  //         setFiles(res.data);
  //       }
  //     })
  //     .catch(error => {
  //       dispatch({ type: FETCH_ERROR, payload: 'Error Loading Documenets  ' });
  //     });
  // };

  // const getDocs = async (isMounted = true) => {
  //   const id = taskData.id;

  //   if (!id) return;

  //   try {
  //     // setIsLoading(true);
  //     dispatch({ type: FETCH_START });

  //     const response = await customAxios.get(`/GenTasks/GetTasksDocs/${id}`, {
  //       headers: authHeader(),
  //     });

  //     console.log(id);

  //     if (response.status === 200 && Array.isArray(response.data)) {
  //       const blobResponses = await Promise.all(
  //         response.data.map(item =>
  //           customAxios.get(`/GenTasks/GetTasksFile/${item.id}`, {
  //             headers: authHeader(),
  //             responseType: 'blob',
  //           }),
  //         ),
  //       );
  //       console.log(response);
  //       const formattedFiles = blobResponses.map((fileRes, idx) => {
  //         const urlObj = URL.createObjectURL(fileRes.data);
  //         return {
  //           id: response.data[idx].id,
  //           documentName: response.data[idx].docName,
  //           type: fileRes.data.type,
  //           urlObj,
  //         };
  //       });

  //       if (isMounted) {
  //         setFiles(formattedFiles);
  //         dispatch({ type: FETCH_SUCCESS });
  //       }
  //     } else {
  //       if (isMounted) {
  //         setFiles([]);
  //         dispatch({ type: FETCH_SUCCESS });
  //       }
  //     }
  //   } catch (err) {
  //     console.error('Error fetching docs:', err);
  //     if (isMounted) dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
  //   }
  // };
  const getDocs = () => {};

  const submitEditedData = async () => {
    try {
      const taskType = taskData.task;
      let payload;

      if (taskType === 'Repairs & Maintainance' || taskType === 'External Repairs') {
        payload = repairAndmaintananceData;
      } else if (taskType === 'Vehicle Check List') {
        payload = drivingData;
      } else {
        payload = generalFormData;
      }

      const username = allUsers?.find(u => u.defaultDriverDisplayName === payload.employeeName)?.email || 'Unknown User';
      payload = { ...payload, driverUserName: username, id: taskData.id };

      // saving data
      let url = '/GenTasks/EditTasks/';
      customAxios
        .post(url, payload, { headers: authHeader() })
        .then(response => {
          handleSuccessfulSubmit();
        })
        .catch(error => {
          console.log('error:', error);
        });

      await updateVehicalCheckList();
      await uploadNewDocs();

      handleClose();
    } catch (err) {
      console.log('error:', err);
    }
  };

  const updateVehicalCheckList = async () => {
    let url = '/GenTasks/EditTasksVehicleChecklist';
    return new Promise(res => {
      dispatch({ type: FETCH_START });
      customAxios
        .post(url, vehicalCheckList, { headers: authHeader() })
        .then(response => {
          dispatch({ type: FETCH_SUCCESS });

          if (response.status === 200) {
            res(true);
          } else {
            res(false);
          }
        })
        .catch(error => {
          res(false);
          dispatch({ type: FETCH_ERROR, payload: 'Error Editing Task Data ' });
        });
    });
  };
  const uploadNewDocs = async taskData => {
    return new Promise(res => {
      let url = '/GenTasks/AddTasksDocs';
      //taskId ,docType, file
      let formData = new FormData();
      if (!files || files.length == 0) {
        res(true);
        return;
      }
      dispatch({ type: FETCH_START });
      formData.append('taskId', taskData.id);
      formData.append('docType', taskData.selectTask);
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        formData.append(`file[${i}]`, file);
      }

      customAxios
        .post(url, formData, { headers: authHeader() })
        .then(response => {
          if (response.status === 200) {
            dispatch({ type: FETCH_SUCCESS });
            res(true);
          } else {
            res(false);
          }
        })
        .catch(error => {
          res(false);
          dispatch({ type: FETCH_ERROR, payload: 'Error Uploading document ' });
        });
    });
  };

  const handleDrivingDataEdit = (value, name) => {
    setDrivingData(prev => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleTaskChange = newTask => {
    // Reset all form states
    setDrivingData(DEFAULT_DRIVER_DATA);
    setGeneralFormData({});
    setRepairAndmaintananceData({});
    setExpenseClaimData({});

    // ✅ Shared fields from original record
    const sharedFields = {
      dateAndTime: taskData.dateAndTime
        ? taskData.dateAndTime.length > 16
          ? taskData.dateAndTime.substring(0, 16)
          : taskData.dateAndTime
        : '',
      employeeName: taskData.employeeName,
      task: newTask,
    };

    const generalTaskTypes = [
      'Clock In',
      'Administration',
      'Moisture Content',
      'Clock Out',
      'Chainsaw',
      'Other',
      'Break',
      'Nominate Contact',
      'Cancel',
    ];

    // ✅ Now each form gets the shared fields
    if (newTask === 'Vehicle Check List') {
      setDrivingData(prev => ({
        ...DEFAULT_DRIVER_DATA,
        ...sharedFields,
      }));
    } else if (generalTaskTypes.includes(newTask)) {
      setGeneralFormData(sharedFields);
    } else if (newTask === 'Expense Claim') {
      setExpenseClaimData(sharedFields);
    } else if (newTask === 'Repairs & Maintainance' || newTask === 'External Repairs') {
      setRepairAndmaintananceData(sharedFields);
    }
  };

  return {
    handleClose,
    submitEditedData,
    handleDrivingDataEdit,
    drivingData,
    setDrivingData,
    files,
    setFiles,
    uploadNewDocs,
    setNewUploadedFiles,
    EditVehicalCheckListData,
    vehicalCheckList,
    generalFormData,
    repairAndmaintananceData,
    setGeneralFormData,
    setRepairAndmaintananceData,
    expenseClaimData,
    setExpenseClaimData,
    handleTaskChange,
  };
};

export default useGenTasksFormEditHook;
